/* FAQ hero birds — every screen, interactive only where there is a cursor.

   A trimmed port of the flock in sections/zph-sky-hero.liquid (the reviews page
   header). Same boids model: a clamped spring to each flock's centroid, plus
   alignment and separation between neighbours, and flocks recycle as a whole
   unit once every member has cleared the left edge — recycling birds one at a
   time drops a bird on the far side of its own centroid and the group
   slingshots after it.

   INTERACTION. Identical to the reviews hero and gated the same way: a
   pointermove on the stage sets a repulsion point, pointerleave clears it, and
   both listeners are attached ONLY behind
   `(hover: hover) and (pointer: fine)`.

   That is a capability query, not a width query, on purpose. A phone and a
   touch laptop can be the same width; what decides whether proximity means
   anything is whether the device has a cursor that hovers without committing
   to a tap. Where it does not match, none of the code below the guard exists:
   no listener is bound, so no pointer event is ever delivered to this section,
   and the proximity term in step() is dead weight the branch skips. The flock
   still flies — it is only the reaction that is absent. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* Matches sections/zph-sky-hero.liquid. Read once: a device does not grow a
     mouse mid-session, and re-evaluating per frame would be a media query
     lookup on the animation path. */
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function num(el, name, dflt) {
    var v = parseFloat(el.getAttribute(name));
    return isNaN(v) ? dflt : v;
  }

  function init(canvas) {
    if (canvas.__zfbInit) return;
    canvas.__zfbInit = 1;

    var stage = canvas.parentElement;
    var ctx = canvas.getContext('2d');
    if (!stage || !ctx) return;

    var P = {
      count:   num(canvas, 'data-count', 15),
      flocks:  num(canvas, 'data-flocks', 4),
      spacing: num(canvas, 'data-spacing', 58) / 100,
      scale:   num(canvas, 'data-size', 118) / 100,
      flap:    num(canvas, 'data-flap', 85) / 1000,
      alpha:   num(canvas, 'data-opacity', 88) / 100,
      colour:  canvas.getAttribute('data-colour') || '#000000',
      /* Same defaults as the reviews hero's scatter controls, so a cursor
         moved across either sky gets the same reaction. */
      radius:  num(canvas, 'data-radius', 150),
      force:   num(canvas, 'data-force', 28) / 100,
      /* wing geometry — carried over from the reviews hero unchanged */
      home: 0.020, speed: 1.00, flock: 1.00, cohesion: 1.01,
      bank: 0.00, taper: 0.23, bow: 1.79, thick: 1.81, endcap: 1.09
    };

    var W = 0, H = 0, dpr = 1, birds = [], flocks = [];
    /* Stays { live:false } forever on a touch device — nothing writes to it,
       because nothing below is listening. */
    var mouse = { x: -9999, y: -9999, live: false };

    function resize() {
      var r = stage.getBoundingClientRect();
      var w = r.width || stage.offsetWidth, h = r.height || stage.offsetHeight;
      if (w < 2 || h < 2) return false;
      var first = (W === 0);
      W = w; H = h;
      /* 1.5, not devicePixelRatio: the canvas is cleared and repainted every
         frame, so its pixel count is a per-frame cost competing with the
         scroll. The birds are small antialiased fills and the drop does not
         show. */
      dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      /* Assigning width/height reallocates and clears the backing store even
         when the value is unchanged, and this runs from a ResizeObserver — on
         a phone the address bar collapsing mid-scroll fires it repeatedly. */
      var cw = Math.round(W * dpr), ch = Math.round(H * dpr);
      if (canvas.width !== cw || canvas.height !== ch) {
        canvas.width = cw; canvas.height = ch;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      if (first || !birds.length) build(Math.round(P.count));
      return true;
    }

    function makeBird(gi) {
      var f = flocks[gi];
      var z = Math.max(0.06, Math.min(1, f.z + (Math.random() - 0.5) * 0.24));
      return { g: gi, z: z,
        x: f.x + (Math.random() - 0.5) * 150,
        y: f.lane * H + (Math.random() - 0.5) * 54,
        vx: 0, vy: 0,
        wander: Math.random() * Math.PI * 2,
        wanderRate: 0.006 + Math.random() * 0.010,
        phase: Math.random() * Math.PI * 2,
        size: 0.55 + z * 0.95 };
    }

    function build(n) {
      var g = Math.max(1, Math.round(P.flocks)), vw = W || 800, i;
      flocks = [];
      for (i = 0; i < g; i++) {
        flocks.push({
          /* lanes live in the upper half of the hero: below that they fly into
             the headline, and lower still into the water. */
          lane: 0.08 + ((i + 0.2 + Math.random() * 0.6) / g) * 0.34,
          x: vw * 0.85 - i * P.spacing * vw * (0.85 + Math.random() * 0.3),
          z: 0.18 + Math.random() * 0.72
        });
      }
      birds = [];
      for (i = 0; i < n; i++) birds.push(makeBird(i % g));
    }

    function homeVx(b) { return -(0.28 + b.z * 0.55) * P.speed; }

    function step() {
      var cen = [], i, j, b, c, f;
      for (i = 0; i < flocks.length; i++) cen.push({ x: 0, y: 0, n: 0, maxX: -Infinity });
      for (i = 0; i < birds.length; i++) {
        b = birds[i]; c = cen[b.g];
        if (c) { c.x += b.x; c.y += b.y; c.n++; if (b.x > c.maxX) c.maxX = b.x; }
      }
      for (i = 0; i < cen.length; i++) if (cen[i].n) { cen[i].x /= cen[i].n; cen[i].y /= cen[i].n; }

      for (i = 0; i < birds.length; i++) {
        b = birds[i]; f = flocks[b.g]; if (!f) continue;
        var hvx = homeVx(b);
        b.wander += b.wanderRate;
        var hvy = Math.sin(b.wander) * 0.16 + (f.lane * H - b.y) * 0.0018;
        b.vx += (hvx - b.vx) * P.home;
        b.vy += (hvy - b.vy) * P.home;

        c = cen[b.g];
        if (c && c.n > 1) {
          var dvx = (c.x - b.x) * 0.0016 * P.cohesion, dvy = (c.y - b.y) * 0.0032 * P.cohesion;
          b.vx += dvx < -0.05 ? -0.05 : (dvx > 0.05 ? 0.05 : dvx);
          b.vy += dvy < -0.05 ? -0.05 : (dvy > 0.05 ? 0.05 : dvy);
        }

        var ax = 0, ay = 0, sx = 0, sy = 0, nn = 0;
        for (j = 0; j < birds.length; j++) {
          var o = birds[j]; if (o === b) continue;
          var ddx = o.x - b.x, ddy = o.y - b.y, d2 = ddx * ddx + ddy * ddy;
          if (d2 > 0 && d2 < 9000) {
            var d = Math.sqrt(d2);
            ax += o.vx; ay += o.vy; nn++;
            if (d < 34) { sx -= ddx / d; sy -= ddy / d; }
          }
        }
        if (nn) { b.vx += ((ax / nn) - b.vx) * 0.02 * P.flock; b.vy += ((ay / nn) - b.vy) * 0.02 * P.flock; }
        b.vx += sx * 0.05 * P.flock; b.vy += sy * 0.05 * P.flock;

        if (mouse.live) {
          var mdx = b.x - mouse.x, mdy = b.y - mouse.y, md = Math.hypot(mdx, mdy);
          if (md < P.radius && md > 0.01) {
            var push = (P.force * (1 - md / P.radius)) / Math.max(md, 12) * 26;
            b.vx += (mdx / md) * push; b.vy += (mdy / md) * push;
          }
        }

        b.x += b.vx; b.y += b.vy;
        b.phase += P.flap * (1 + Math.max(0, -b.vy) * 0.85);

        var farRight = W + Math.max(600, P.spacing * W * (flocks.length + 1));
        if (b.x > farRight) { b.x = farRight; b.vx = Math.min(b.vx, 0); }
        if (b.y < -70)    { b.y = -70;    b.vy = Math.abs(b.vy) * 0.4; }
        if (b.y > H + 70) { b.y = H + 70; b.vy = -Math.abs(b.vy) * 0.4; }
      }

      for (var gi = 0; gi < flocks.length; gi++) {
        c = cen[gi];
        if (!c || !c.n || c.maxX > -70) continue;
        f = flocks[gi];
        var rear = W;
        for (i = 0; i < cen.length; i++) if (cen[i].n && cen[i].x > rear) rear = cen[i].x;
        f.x = rear + P.spacing * W * (0.85 + Math.random() * 0.30);
        var lane = 0.08 + Math.random() * 0.34, tries = 0, clash = true;
        while (tries++ < 12 && clash) {
          clash = false;
          for (i = 0; i < flocks.length; i++) {
            if (i !== gi && Math.abs(flocks[i].lane - lane) < 0.11) { clash = true; break; }
          }
          if (clash) lane = 0.08 + Math.random() * 0.34;
        }
        f.lane = lane;
        for (i = 0; i < birds.length; i++) {
          b = birds[i]; if (b.g !== gi) continue;
          b.x = f.x + (Math.random() - 0.5) * 150;
          b.y = f.lane * H + (Math.random() - 0.5) * 54;
          b.vx = homeVx(b); b.vy = 0;
        }
      }
    }

    /* Wings are filled and tapered — a constant-width stroke cannot come to a
       point. The endpoint cap bulges along the leading edge's TANGENT, not
       horizontally, or it hangs off an angled wing as a knob. */
    function paintBird(b, col, s) {
      var flap = Math.sin(b.phase);
      var span = 7.5 * s, tip = -flap * 3.6 * s;
      var rot = Math.atan2(b.vy * P.bank, b.vx);
      if (rot >  Math.PI / 2) rot -= Math.PI;
      if (rot < -Math.PI / 2) rot += Math.PI;
      var bow = P.bow * s + Math.abs(tip) * 0.15;
      var w   = Math.max(1.1, P.thick * s);
      var tw  = w * P.taper;
      var ext = P.endcap * (tw * 0.95 + s * 0.35);
      ctx.fillStyle = col;
      ctx.save();
      ctx.translate(b.x, b.y);
      ctx.rotate(rot);
      for (var k = 0; k < 2; k++) {
        var sgn = k ? 1 : -1;
        var tgx = sgn * span - sgn * span * 0.48;
        var tgy = (tip - tw * 0.5) - (bow - w * 0.28);
        var tl  = Math.hypot(tgx, tgy) || 1;
        ctx.beginPath();
        ctx.moveTo(0, -w * 0.5);
        ctx.quadraticCurveTo(sgn * span * 0.48, bow - w * 0.28, sgn * span, tip - tw * 0.5);
        ctx.quadraticCurveTo(sgn * span + (tgx / tl) * ext, tip + (tgy / tl) * ext,
                             sgn * span, tip + tw * 0.5);
        ctx.quadraticCurveTo(sgn * span * 0.44, bow + w * 0.62, 0, w * 0.5);
        ctx.closePath();
        ctx.fill();
      }
      ctx.restore();
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = P.alpha;
      for (var i = 0; i < birds.length; i++) paintBird(birds[i], P.colour, birds[i].size * P.scale);
      ctx.globalAlpha = 1;
    }

    var raf = null, visible = true;
    function loop() {
      if (visible) { step(); draw(); }
      raf = requestAnimationFrame(loop);
    }
    function start() { if (!raf && !reduce.matches) raf = requestAnimationFrame(loop); }
    function stop()  { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; },
        { rootMargin: '120px' }).observe(stage);
    }
    if (window.ResizeObserver) new ResizeObserver(function () { resize(); }).observe(stage);
    window.addEventListener('resize', function () { resize(); }, { passive: true });

    /* CURSOR SCATTER — desktop only.
       Nothing here is attached on a touch device: no listener, so no pointer
       event is delivered and no proximity work is scheduled. The pointerType
       check is the second gate, for a hybrid machine that answers yes to
       (hover:hover) and is then poked with a finger or a pen — a stylus should
       not act as a cursor here. Both listeners are passive: this reaction must
       never cost the page its scroll. */
    if (fine.matches) {
      stage.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        var r = stage.getBoundingClientRect();
        mouse.x = e.clientX - r.left;
        mouse.y = e.clientY - r.top;
        mouse.live = true;
      }, { passive: true });
      stage.addEventListener('pointerleave', function () { mouse.live = false; }, { passive: true });
    }

    resize();
    canvas.__zfbStop = stop;
    if (reduce.matches) { draw(); } else { start(); }
    reduce.addEventListener('change', function () {
      if (reduce.matches) { stop(); draw(); } else { start(); }
    });
  }

  document.querySelectorAll('[data-zfaq-birds]').forEach(init);
})();
